import { Button, Form, Input, message, Modal } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { IconButton } from "@mui/material";
import "../Styles/Profile.css";
import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import TextArea from "antd/es/input/TextArea";
const Profile = () => {
  const [form] = Form.useForm();
  // eslint-disable-next-line no-unused-vars
  const [store, setStore] = useState({});
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://bardawamplus.com/api/stores/${Cookies.get("store")}`
        );
        setStore(response.data);
        // console.log("response", response.data);

        const product = response.data; // Assuming product is part of the store data
        const nameObj = JSON.parse(product?.name || "{}"); // Ensure safe parsing
        const descriptionObj = JSON.parse(product?.address || "{}"); // Ensure safe parsing
        const LogoImage = product.logo ? `${product.logo}` : null;
        // console.log("LogoImage", LogoImage);
        setLogo(LogoImage);
        form.setFieldsValue({
          TitleKurdish: nameObj.ku || "",
          TitleArabic: nameObj.ar || "",
          number: product?.number || "",
          email: product?.email || "",
          DescriptionKurdish: descriptionObj.ku || "",
          DescriptionArabic: descriptionObj.ar || "",
        });
      } catch (error) {
        console.error("Error fetching store data:", error);
      }
    };

    fetchData();
  }, [form]);
  //todo Image =============================================
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const handleImageChange = async (file) => {
    // Generate a preview URL for the image file
    const previewUrl = URL.createObjectURL(file);
    setImagePreviewUrl(previewUrl);
    // Proceed with the upload logic
    const formData = new FormData();
    formData.append("file", file);
    const response = await axios.post(
      "https://bardawamplus.com/api/upload-file",
      formData
    );
    if (response.status === 200) {
      const imageUrl = response.data.path;
      setLogo(imageUrl);
      // message.success("Image uploaded successfully");
      // Revoke the preview URL after upload is successful
      URL.revokeObjectURL(previewUrl);
    } else {
      message.error("Failed to upload image");
    }
  };
  const normFile = (e) => {
    return e && e.fileList ? [e.file] : [];
  };
  const onChangeUpload = async (e) => {
    if (e && e.target && e.target.files) {
      const file = e.target.files[0];
      await handleImageChange(file);
    }
  };

  //todo this is Modal  Name
  const [isModalOpenNew, setIsModalOpenNew] = useState(false);
  // const [form] = Form.useForm(); // Form instance for the outer form
  const handleCancelNew = () => {
    setIsModalOpenNew(false);
  };
  const showModalNew = () => {
    setIsModalOpenNew(true);
  };

  const handleOkNew = () => {
    setIsModalOpenNew(false);
  };
  //! End modal
  //todo this is Modal  Description
  const [isModalOpenNew2, setIsModalOpenNew2] = useState(false);
  // const [form] = Form.useForm(); // Form instance for the outer form
  const handleCancelNew2 = () => {
    setIsModalOpenNew2(false);
  };
  const showModalNew2 = () => {
    setIsModalOpenNew2(true);
  };

  const handleOkNew2 = () => {
    setIsModalOpenNew2(false);
  };
  //! End modal
  const onFinish = async (values) => {
    try {
      values["logo"] = logo;
      const name = {
        ar: form.getFieldValue("TitleArabic"),
        ku: form.getFieldValue("TitleKurdish"),
      };
      const address = {
        ar: form.getFieldValue("DescriptionArabic"),
        ku: form.getFieldValue("DescriptionKurdish"),
      };
      // Prepare the updated values
      const updatedValues = {
        ...values,

        number: values.number, // Keeping number as is
        name: name,
        address: address,
      };

      // console.log("Updated Values:", updatedValues); // Print updated values for debugging

      // Route::put('/stores/{id}/pstbdp', [StoreController::class, 'update']);

      const response = await axios.put(
        // `https://bardawamplus.com/api/stores/${Cookies.get("store")}`,
        `https://bardawamplus.com/api/stores/${Cookies.get("store")}/pstbdp`,
        updatedValues
      );

      if (response.status >= 200 && response.status < 300) {
        message.success("Successfully updated");
      } else {
        message.error(`Unexpected response status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error during update:", error); // Detailed error logging
      message.error("Failed to update. Please try again.");
    }
  };

  const onFinishFailed = () => {
    // console.log("Failed:", errorInfo);
    message.error("Error");
  };
  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
  };
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>update Profile</h1>

      {/* //! end image ================================= */}
      <Form
        form={form}
        {...layout}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        {/* //todo this is image  */}
        <div className="centered-form-item">
          <Form.Item
            name="image-url"
            // label={"image"}
            valuePropName="fileList"
            getValueFromEvent={normFile}
          >
            <input
              id="single-image-upload"
              type="file"
              style={{ display: "none" }}
              onChange={onChangeUpload}
            />
            <label htmlFor="single-image-upload">
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
                className="upload-button"
              >
                UpdateImage
              </IconButton>
            </label>
            {imagePreviewUrl ? (
              <img
                src={imagePreviewUrl}
                alt="Preview of the selected file"
                className="image-preview"
              />
            ) : logo ? (
              <img
                src={`https://bardawamplus.com/api/storage/${logo}`}
                alt="Uploaded file preview"
                className="image-preview"
              />
            ) : null}
          </Form.Item>
        </div>
        {/* //todo this is name  */}
        <div className="NameAdders">
          <Form.Item name="name">
            <Button type="text" className="ButtonName" onClick={showModalNew}>
              <div className="OnButton">
                Name
                <DownOutlined />
              </div>
            </Button>

            <Modal
              title="Name"
              open={isModalOpenNew}
              onOk={handleOkNew}
              onCancel={handleCancelNew}
              footer={
                <div>
                  <Button
                    type="primary"
                    onClick={handleOkNew}
                    style={{
                      width: "30%",
                    }}
                  >
                    save
                  </Button>
                  <span> </span>
                  <Button onClick={handleCancelNew}>cancel</Button>
                </div>
              }
            >
              <Form
                form={form}
                onFinishFailed={onFinishFailed}
                initialValues={{ remember: true }}
              >
                <Form.Item name="TitleKurdish" label="Kurdish">
                  <Input placeholder="Type your Title Kurdish" />
                </Form.Item>
                <Form.Item name="TitleArabic" label="Arabic">
                  <Input placeholder="Type your Title Arabic" />
                </Form.Item>
              </Form>
            </Modal>
          </Form.Item>
        </div>
        {/* //todo ----------------------------------------------- */}

        <Form.Item name="number" label="_">
          <Input
            style={{ width: "40%", paddingLeft: 20 }}
            placeholder="Type your number"
          />
        </Form.Item>

        {/* //todo this is description */}
        <div className="NameAdders">
          <Form.Item name="name">
            <Button type="text" className="ButtonName" onClick={showModalNew2}>
              <div className="OnButton">
                address
                <DownOutlined />
              </div>
            </Button>

            <Modal
              title="Address"
              open={isModalOpenNew2}
              onOk={handleOkNew2}
              onCancel={handleCancelNew2}
              footer={
                <div>
                  <Button
                    type="primary"
                    onClick={handleOkNew2}
                    style={{
                      width: "30%",
                    }}
                  >
                    save
                  </Button>
                  <span> </span>
                  <Button onClick={handleCancelNew2}>cancel</Button>
                </div>
              }
            >
              <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{ remember: true }}
              >
                <Form.Item name="DescriptionKurdish" label="Address Kurdish">
                  <TextArea
                    showCount
                    maxLength={250}
                    style={{
                      height: 65,
                      resize: "none",
                    }}
                    placeholder="Type your Title Kurdish"
                  />
                </Form.Item>
                <Form.Item name="DescriptionArabic" label="Address Arabic">
                  <TextArea
                    showCount
                    maxLength={250}
                    // onChange={onChange}
                    style={{
                      height: 65,
                      resize: "none",
                    }}
                    placeholder="Type your Title Arabic"
                  />
                </Form.Item>
              </Form>
            </Modal>
          </Form.Item>
        </div>

        {/* //! ----------------------------------------------- */}

        <Form.Item label=".">
          <div className="form-buttons-container">
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            <Button
              type="primary"
              danger
              onClick={() => (window.location.href = "/")}
            >
              Dashboard
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Profile;
